<template>
  <div>
    <common-dialog
      ref="dialog"
      width="900px"
      title="详情 软件需求"
      id-key="RequirementId"
      :data="data"
      :get-data-func="api.info"
      @details-opened="onDetailsOpened"
    >
      <template slot="form">
        <fieldset>
          <legend>申请概要</legend>
          <el-row>
            <el-col :span="12">
              <el-form-item label="申请时间">
                <span>{{$commonJs.toDateString(data.ApplyDate)}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="申请类型">
                <span>{{data.ApplyTypeName}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="申请标题">
                <span>{{data.Title}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="系统名称">
                <span>{{data.SystemName}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="模块名称">
                <span>{{data.ModuleName}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </fieldset>
        <fieldset style="margin-top: 30px;">
          <legend>具体描述</legend>
          <el-row class="desc" v-for="(item, index) in data.Descriptions" :key="index">
            <el-col :span="24">
              <el-row style="display: flex;flex-wrap: wrap;">
                <el-image
                  class="img"
                  v-for="(pic, pindex) in item.Pictures"
                  :key="pindex"
                  :src="getUrl(pic.Url)"
                  :preview-src-list="item.Pictures.map(x => getUrl(x.Url))"
                ></el-image>
              </el-row>
              <el-row style="margin: 10px 0;padding-left: 5px">
                <label style="margin-right: 10px;">文字描述</label>
                <span>{{item.Remark}}</span>
              </el-row>
            </el-col>
          </el-row>
        </fieldset>
        <fieldset style="margin-top: 30px;">
          <legend>流程日志</legend>
          <el-row class="log" v-for="(item, index) in data.Logs" :key="index">
            <el-col :span="5">
              <span>{{item.Node}}</span>
            </el-col>
            <el-col :span="5">
              <span>{{item.EmpName}}</span>
            </el-col>
            <el-col :span="4">
              <span>{{item.Action}}</span>
            </el-col>
            <el-col :span="10">
              <span v-if="item.Remark">退回原因：{{item.Remark}}</span>
            </el-col>
          </el-row>
        </fieldset>
      </template>
      <template slot="footer">
        <el-button size="mini" @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import editDialogMixin from "@/mixins/editDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        RequirementId: 0,
        EmpId: 0,
        EmpName: "",
        DpId: 0,
        ApplyDate: null,
        ApplyTypeId: null,
        ApplyTypeName: null,
        Title: "",
        SystemId: null,
        SystemName: "",
        ModuleId: null,
        ModuleName: "",
        StartDate: null,
        PlanDate: null,
        DeployDate: null,
        CurrentNode: "",
        ApplyTime: null,
        Status: 0,
        StatusText: "",
        Descriptions: [],
        Logs: [],
      },
      api: require("@/api/bm/requirement").default,
    };
  },
  computed: {},
  methods: {
    getUrl(url) {
      // var img_url = "http://localhost:9500" + url;
      var img_url = window.location.origin + "/Api" + url;
      // console.log(window.location);
      return img_url;
    },
    onDetailsOpened() {
      console.log("onDetails", this.data);
    },
  },
};
</script>
<style lang="scss">
.desc {
  border-bottom: 1px solid #909090;
}
.img {
  width: 120px;
  height: 120px;
  margin: 5px;
  border: 1px solid #9c9c9c;
}
.log {
  margin: 5px 0px;
  padding-left: 5px;
}
</style>